import FinanceiroPage from "./FinanceiroPage";
export default FinanceiroPage;